import { render, staticRenderFns } from "./NavbarTopHub.vue?vue&type=template&id=132765be"
import script from "./NavbarTopHub.vue?vue&type=script&lang=js"
export * from "./NavbarTopHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports